import { FC } from 'react';
import ProDescriptions, { DescriptionsProps } from './descriptions';
import ProDescriptionsItem, { DescriptionsItemProps } from './item';

export type IDescriptionsComponent = FC<DescriptionsProps> & {
  Item: FC<DescriptionsItemProps>;
};

const TransDescriptions = ProDescriptions as IDescriptionsComponent;
TransDescriptions.Item = ProDescriptionsItem;

export default TransDescriptions;
